import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const getSubscriptionPlans = (params?: any) => {
  return axios({
    url: `/plans`,
    method: "GET",
    params,
  });
};

export const getTenetRoles = (params?: any) => {
  return axios({
    url: `/roles`,
    method: "GET",
    params,
  });
};

export const createTenet = (data: any) => {
  return axios({
    method: "POST",
    url: `/tenant`,
    data,
  });
};

export const getTenets = (params?: any) => {
  return axios({
    method: "GET",
    url: `/tenant`,
    params,
  });
};
export const getTenantsList = (params?: any, moduleName?: string) => {
  return axios({
    method: "GET",
    url: `/tenants-list`,
    params,
    headers: {
      Authorization: `${token}`,
    },
  });
};

export const uploadTenetLogo = (data: any) => {
  return axios({
    method: "POST",
    url: `/tenant/upload-logo`,
    data,
  });
};

export const updateTenetStatus = (id: number, data: { status: string }) => {
  return axios({
    method: "PUT",
    url: `/tenant/${id}/status`,
    data,
  });
};

export const updateTenetDetails = (
  tenantId: number,
  section: string,
  data: {}
) => {
  return axios({
    method: "PUT",
    url: `/tenant/${tenantId}/update/${section}`,
    data,
  });
};

export const getTenantDetails = (params?: { id: string | number }) => {
  return axios({
    method: "GET",
    url: `/tenant/${params?.id}`,
    params: {},
  });
};

export const updateTenetUsers = (id: number, data: any) => {
  return axios({
    method: "PUT",
    url: `/tenant/${id}/users`,
    data,
  });
};

export const changeSubscriptionPlan = (id: number, data: any) => {
  return axios({
    method: "PUT",
    url: `/tenant/${id}/changePlan`,
    data,
  });
};

export const updateTenetDetailsLogo = (id: any, data: any) => {
  return axios({
    method: "PUT",
    url: `/tenant/${id}/update/logo `,
    data,
  });
};

export const resendPaymentLink = (tenantId: any) => {
  return axios({
    method: "POST",
    url: `/tenant/${tenantId}/resend-payment-link`,
  });
};

export const validatePartnerCompany = (params?: { companyName: string }) => {
  return axios({
    method: "GET",
    url: `/tenant/company-exist`,
    params,
  });
};

export const resendCredentialEmail = (tenantId: number, userId: number) => {
  return axios({
    method: "POST",
    url: `/tenant/${tenantId}/users/${userId}/resend-credential-email`,
  });
}

export const getLinkedPartnerStatus = (tenantId: number) => {
  return axios({
    method: "GET",
    url: `/tenant/${tenantId}/linked-partner-status`,
  });
}

export const searchPartner = (params: { searchType: string; searchValue: string }) => {
  return axios({
    method: "GET",
    url: `/tenant/search/memgo-partner`,
    params,
  });
}

export const linkPartner = (tenantId: number, memgoPartnerId: number) => {
  return axios({
    method: "POST",
    url: `/tenant/${tenantId}/link-partner`,
    data: { memgoPartnerId },
  });
}